import { UAParser } from "ua-parser-js";

export function isMacOs() {
  const os = new UAParser().getOS().name;
  return os === "Mac OS";
}
